import styled from "styled-components";

export const StyledInput = styled.div<{ hasFieldError?: boolean }>`
    display: flex;
    flex-direction: column;
    position: relative;
    transform: ${(props) => (props.hasFieldError ? `translate(0, 10px)` : `translate(0)`)};

    input {
        font-size: ${(props) => props.theme.typography.body.medium.fontSize};
        border: none;
        background-color: transparent;
        border: 1px solid
            ${(props) =>
                props.hasFieldError
                    ? props.theme.colors.alert.error
                    : props.theme.colors.neutral.neutral200};
        border-radius: 4px;
        height: 46px;
        padding: ${(props) => props.theme.spacing.xs} ${(props) => props.theme.spacing.sm};
        :focus {
            border-bottom: 1px solid ${(props) => props.theme.colors.secondary.secondary700};
            outline: none;
        }

        ::placeholder {
            color: ${(props) => props.theme.colors.neutral.neutral200};
        }

        /* Fix for Edge user agent styles setting with to 10 em on type date inputs */
        &[type="date"] {
            width: auto;
        }
    }
`;
